/**
 * お問い合わせフォームの要素を生成するクラス
 *
 * @constructor
 *   @param {Object} obj
 *     @param {String} title お問い合わせのタイトル
 *     @param {String} type inputやtextareaなどの要素を指定する
 *     @param {String} name inputやtextareaなどのname属性の指定
 *     @param {String} example input下の文字を設定
 *     @param {String} note ふきだし部分のテキストを設定
 *     @param {Boolean} required 必須項目に設定
 *     現在対応しているtype: [text,textarea,checkbox]
 * @author Akiyama Yuya
 * @version 1.0.0
 */
class ZATY_ContactItem {
  constructor () {
    this.indexObj = []
  }

  /**
   * 設定のobjectをセットしてinit()を実行する
   * @param {Object} obj
   */
  setObj (obj) {
    try {
      /**
       * テンプレート初期設定
       */
      this._title = typeof obj.title !== 'undefined' ? obj.title : this._title
      this._type = typeof obj.type !== 'undefined' ? obj.type : this._type
      this._name = typeof obj.name !== 'undefined' ? obj.name : this._name
      this._example = typeof obj.example !== 'undefined' ? obj.example : this._example

      this._required = !!obj.required

      this._note = typeof obj.note !== 'undefined' ? obj.note : this._note

      /**
       * エラー初期設定
       */
      this.err = typeof obj.err === 'undefined' ? false : obj.err
      this.err_match = typeof obj.error !== 'undefined' ? obj.error.match : null
      this.err_text = typeof obj.error !== 'undefined' ? obj.error.text : null

      /**
       * checkbox初期設定
       */
      this._label = typeof obj.label !== 'undefined' ? obj.label : this._label

      this.init()
    } catch (e) {
      console.error(e.message)
    }
  }

  /**
   * this._mainにContactItemを格納する
   * ここでタイプを識別するthis.typeSetting()を実行する
   */
  init () {
    this.dom = {}
    this.inputFlag = false
    this._main = this.templateCreate()

    this.typeSetting()
    try {
      if (!this.inputFlag) {
        throw new Error('指定したType属性は対応していません。')
      }
    } catch (e) {
      console.error(e.message)
    }
  }

  /**
   * データの変更を制御
   * @param {Object} obj クラス生成時の引数と同じ
   */
  set obj (obj) {
    this.indexObj.push(obj)
    this.setObj(obj)
  }

  /**
   * 設定した要素を表示する
   * @param  {Node Object} parentDom コンタクト要素を挿入するNode Object
   */
  render (parentDom) {
    if (!parentDom) return
    const childNode = this._main.cloneNode(true)
    this.seted_note = typeof this._note !== 'undefined' && this._note !== null
    this.noteListener(childNode.querySelector('.jsZatyInput'))

    childNode.querySelector('.jsZatyInput').value = parentDom.dataset.value ? parentDom.dataset.value : ''

    parentDom.appendChild(childNode)
  }

  /**
   * テンプレートのDOMを生成
   * @return {Node Object}
   */
  templateCreate () {
    const mainDom = this.createDom('div', 'zaty-contact-item')
    this.dom.titleDom = this.createDom('p', 'zaty-contact-item__name', this._title, '', mainDom)
    if (this._required) {
      this.dom.requiredDom = this.createDom('span', 'zaty-contact-item__required', '*', '', this.dom.titleDom)
    }
    this.dom.contentDom = this.createDom('div', 'zaty-contact-item__content', '', '', mainDom)
    this.dom.contentDom.classList.add('zatyContent')
    this.dom.contentDom.setAttribute('style', '--inputPadding: 0px;')

    this.dom.contentDom.classList.add('zaty-contact-item__content--note')
    this.dom.noteWrapperDom = this.createDom('div', 'zaty-contact-item__wrap-note', '', '', this.dom.contentDom)
    this.dom.noteWrapperDom.classList.add('zatyWrapperNote')
    this.dom.noteDom = this.createDom('p', 'zaty-contact-item__note', '', '', this.dom.noteWrapperDom)
    this.dom.noteDom.classList.add('zatyNote')

    this.dom.inputDom = this.createDom('div', 'zaty-contact-item__input', '<p class="zaty-contact-item__dummy">s</p>', '', this.dom.contentDom)
    if (this._example) {
      const exampleDom = this.createDom('p', 'zaty-contact-item__example', this._example, '', this.dom.contentDom)
    }

    return mainDom
  }

  typeSetting () {
    switch (this._type) {
      case 'text':
        this.create.textCreate(this.dom.inputDom)
        break
      case 'textarea':
        this.create.textareaCreate(this.dom.inputDom)
        break
      case 'checkbox':
        this.create.checkbox(this.dom.inputDom)
        break
    }
  }

  /**
   * typeによるインプット部分の関数
   */
  create = {
    textCreate: dom => {
      const textInput = this.createDom('input', 'jsZatyInput', '', [{ key: 'type', val: 'text' }, { key: 'name', val: this._name }], dom)
      this.inputFlag = true
    },
    textareaCreate: dom => {
      const textInput = this.createDom('textarea', 'jsZatyInput', '', [{ key: 'name', val: this._name }], dom)
      this.inputFlag = true
    },
    checkbox: dom => {
      try {
        const svg = `<div class="zaty-contact-item__checkbox-bg"></div><span><svg xmlns="http://www.w3.org/2000/svg" width="8.631" height="6.375" viewBox="0 0 8.631 6.375">
          <path d="M-0.421,3.201l1.529,2.427,6.36-5.242" fill="none" stroke="#333" stroke-dashoffset="20" stroke-width="1"/>
        </svg></span>`
        const checkboxLabel = this.createDom('label', 'zaty-contact-item__checkbox', '', [], dom)
        const checkboxInput = this.createDom('input', 'jsZatyInput', '', [{ key: 'type', val: 'checkbox' }, { key: 'name', val: this._name }], checkboxLabel)
        checkboxLabel.innerHTML += svg + '<p>' + this._label + '</p>'

        this.inputFlag = true
      } catch (e) {
        console.error(e.message)
      }
    }
  }

  /**
   * フォーカス時にコメントを追加する
   * @param  {Node Object} node inputやtextareaのNode Object
   */
  noteListener (node) {
    node.addEventListener('focus', {
      handleEvent: this.focusInput,
      has_note: this.seted_note,
      has_err: this.err,
      err_match: this.err_match,
      default_note: this._note
    })
    node.addEventListener('focusout', {
      handleEvent: this.focusoutInput,
      title: this._title,
      required: this._required,
      has_err: this.err,
      err_text: this.err_text,
      err_match: this.err_match,
      has_note: this.seted_note
    })
  }

  /**
   * フォーカスした時のコールバック
   * @param  {Event} e event引数
   */
  focusInput (e, args = null) {
    const that = args || this
    const eventTarget = e.isTrusted ? e.currentTarget : e

    if (that.has_note) {
      const targetContentDom = eventTarget.closest('.zatyContent')
      const targetWrapperDom = targetContentDom.querySelector('.zatyWrapperNote')
      const targetNoteDom = targetContentDom.querySelector('.zatyNote')
      targetNoteDom.innerText = that.default_note
      if (!that.has_err && eventTarget.value.match(that.err_match)) {
        targetContentDom.classList.remove('zaty-contact-item__content--err')
      }

      const height = targetWrapperDom.clientHeight + 8

      targetContentDom.setAttribute('style', '--inputPadding:' + height + 'px;')
      targetWrapperDom.classList.add('zaty-contact-item__wrap-note--on')
    }
  }

  /**
   * フォーカスアウトした時のコールバック
   * @param  {Event} e event引数
   */
  focusoutInput (e, args = null) {
    const that = args || this
    const eventTarget = e.isTrusted ? e.currentTarget : e

    const targetContentDom = eventTarget.closest('.zatyContent')

    const targetWrapperDom = targetContentDom.querySelector('.zatyWrapperNote')
    const targetNoteDom = targetContentDom.querySelector('.zatyNote')

    if (that.required && eventTarget.value === '') {
      targetContentDom.classList.add('zaty-contact-item__content--err')
      targetNoteDom.innerText = that.title + 'は必須項目です。'
      const height = targetWrapperDom.clientHeight + 8

      targetContentDom.setAttribute('style', '--inputPadding:' + height + 'px;')
      targetWrapperDom.classList.add('zaty-contact-item__wrap-note--on')

      eventTarget.dataset.err = '1'
    } else if (that.has_err && !eventTarget.value.match(that.err_match) && eventTarget.value !== '') {
      targetContentDom.classList.add('zaty-contact-item__content--err')
      targetNoteDom.innerText = that.err_text
      const height = targetWrapperDom.clientHeight + 8

      targetContentDom.setAttribute('style', '--inputPadding:' + height + 'px;')
      targetWrapperDom.classList.add('zaty-contact-item__wrap-note--on')

      eventTarget.dataset.err = '1'
    } else {
      targetContentDom.setAttribute('style', '--inputPadding: 0px;')
      targetWrapperDom.classList.remove('zaty-contact-item__wrap-note--on')
      setTimeout(() => {
        targetContentDom.classList.remove('zaty-contact-item__content--err')
      }, 200)

      eventTarget.dataset.err = '0'
    }
  }

  /**
   * 要素を生成する。
   * @version 1.0.0
   *
   * @param  {String} dom DOMの種類
   * @param  {String} cl [cl=""]  クラス属性
   * @param  {String} inner [inner=""]  innerHTML
   * @param  {Array}  obj [obj=[]] [{key:属性,val:value},{...}]の形式で渡す
   * @param  {HTMLObject} append appendChildする場合は親の要素を指定
   * @return {Object} HTML Elementを返す
   */
  createDom (dom, cl = '', inner = '', obj = [], append = '') {
    const returnEl = document.createElement(dom)
    if (cl !== '') {
      returnEl.classList.add(cl)
    }
    if (obj.length) {
      obj.forEach((attr, i) => {
        returnEl.setAttribute(attr.key, attr.val)
      })
    }
    if (inner !== '') {
      returnEl.innerHTML = inner
    }
    if (append !== '') {
      append.appendChild(returnEl)
    }
    return returnEl
  }

  /**
   * ボタンを制御する静的メソッド
   */
  buttonClick (e, node, type = 'submit') {
    if (!node) return
    switch (type) {
      case 'submit':

        break
      case 'confirm':
        const contentArray = S('.jsZatyInput')
        let errFlag = 0
        contentArray.forEach((content, i) => {
          const contentArgs = {
            title: this.indexObj[i].title,
            required: this.indexObj[i].required,
            has_err: this.indexObj[i].err,
            has_note: this.indexObj[i].note
          }
          if (contentArgs.has_err) {
            contentArgs.err_text = this.indexObj[i].error.text
            contentArgs.err_match = this.indexObj[i].error.match
          }
          if (contentArgs.title !== 'privacy') {
            this.focusoutInput(content, contentArgs)
          } else if (!content.checked && errFlag === 0) {
            errFlag = 2
          }

          if (content.dataset.err === '1') {
            errFlag = 1
          }
        })
        if (errFlag !== 0) {
          e.preventDefault()
        }
        if (errFlag === 1) {
          alert('入力内容に問題があります。確認して再度お試しください。')
        } else if (errFlag === 2) {
          alert('お問い合わせ前に、個人情報の取り扱いを確認して同意してください。')
        }
        break
    }
  }
}
module.exports = ZATY_ContactItem
